import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { RequestService } from 'src/app/shared/services/request/request.service';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  private networkStatus$?: Observable<any>;

  constructor(private _requestService: RequestService) { }

  listWorksHome(data): Observable<any> {
    const url = `work/ListWorksOfHome`;
    return this._requestService.requestMethod(url, 'POST', true, data);
  }

  listQuantityWorks(): Observable<any> {
    const url = `work/ListQuantityWorksOfHome`;
    return this._requestService.requestMethod(url, 'GET', true);
  }

  markWorksSeen(idObra): Observable<any> {
    const url = `work/${idObra}/set-seen`;
    return this._requestService.requestMethod(url, 'POST', true);
  }

   listResponsables(): Observable<any> {
    return this._requestService.requestMethod(
      `work/Responsibles`,
      'GET',
      true,
      null
    );
  }

  getTaskSummary(periodoDias: number = 30): Observable<any> {
    return this._requestService.requestMethod(
      `work/Schedule/Summary?periodoDias=${periodoDias}`,
      'GET',
      true,
      null
    );
  }
 
  getNewOpportunities(diasFiltro: number = 7): Observable<any> {
    return this._requestService.requestMethod(
      `work/Opportunities/New?diasFiltro=${diasFiltro}`,
      'GET',
      true,
      null
    );
  }

    getCompanyTaskSummary(periodoDias: number): Observable<any> {
    return this._requestService.requestMethod(
      `company/api/CompanyTask/Summary?periodoDias=${periodoDias}`,
      'GET',
      true,
    );
  }
    listCompanySavedSearches(body: any): Observable<any> {
    return this._requestService.requestMethod(
      'company/api/CompanySavedSearch/ListSavedSearches',
      'POST',
      true,
      body,
    );
  }

  portfolioOverview(teamView = false, responsibleId = 0): Observable<any> {
    return this._requestService.requestMethod(
      `company/api/Company/GetPortfolioOverview?teamView=${teamView}&responsibleId=${responsibleId}`,
      'GET',
      true,
      null,
    );
  }

     
  getNetworkStatus(diasFiltro: number = 7, diasSemInteracao: number = 10): Observable<any> {
    if (!this.networkStatus$) {
      this.networkStatus$ = this._requestService
        .requestMethod(`work/Network/Status?diasFiltro=${diasFiltro}&diasSemInteracao=${diasSemInteracao}`, 'GET', true)
        .pipe(shareReplay({ bufferSize: 1, refCount: false }));
    }
    return this.networkStatus$;
  }

}
